import styled from "styled-components";

export const NormalFont = styled.span`
  font-weight: normal;
`;
